import { render, staticRenderFns } from "./OrderablePaymentMethod.vue?vue&type=template&id=55995e02&"
import script from "./OrderablePaymentMethod.vue?vue&type=script&lang=ts&"
export * from "./OrderablePaymentMethod.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports